/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import { WindowType } from 'types/windowType';
import { getTrans } from '../CACTA/JSComponents/JS/translations';
import { getCAConfig } from '../utils/ca-env';

declare const window: WindowType;
let bannerCache = { bannerPageURls: {} };

const isSearchOrDesignPage = () => {
  const caChatConfig = getCAConfig();
  const path = window.location.pathname;
  const { locale } = caChatConfig;
  const notAllowedLocales = [
    'en-us',
    'en-ca',
    'en-au',
    'en-nz',
    'en-sg',
    'it-ch',
    'it-it',
    'sv-se',
    'fi-fi',
    'nb-no',
    'es-es',
    'es-us',
    'nl-nl',
    'nl-be',
    'da-dk',
    'fr-be',
    'fr-fr',
    'fr-ch',
    'de-at',
    'de-ch',
    'en-ie',
    'en-gb',
    'de-de',
    'fr-ca',
  ];

  if (path.includes(getTrans('search')) && !notAllowedLocales.includes(locale)) {
    return { isSearchOrDesignPage: true, pageName: 'Search' };
  }
  if (path.includes(getTrans('my-account-projects')) || path.includes(getTrans('my-account-uploads'))) {
    return { isSearchOrDesignPage: false, pageName: '' };
  }
  if (path.includes(getTrans('design')) || path.includes('/design')) {
    return { isSearchOrDesignPage: true, pageName: 'Design' };
  }
  return { isSearchOrDesignPage: false, pageName: '' };
};

const updateStudioButton = (enableButton: boolean) => {
  if (enableButton) {
    const helpButtonElement = document.querySelector('[data-testid="designHelp"]') as HTMLButtonElement;
    if (helpButtonElement) helpButtonElement.style.display = 'flex';
  } else {
    const helpButtonElement = document.querySelector('[data-testid="designHelp"]') as HTMLButtonElement;
    if (helpButtonElement) helpButtonElement.style.display = 'none';
  }
};

const isStudioButtonEnabled = () => {
  const helpButtonElement = document.querySelector('[data-testid="designHelp"]') as HTMLButtonElement;
  if (helpButtonElement && helpButtonElement.style.display !== 'none') return true;
  return false;
};

const updateButtonState = (innerText: string, disableButton: boolean) => {
  const { pageName } = isSearchOrDesignPage();
  const buttonName = pageName === 'Search' ? 'liveChatButton' : 'onlineBtn';
  const startButton = document.getElementById(buttonName) as HTMLButtonElement;
  const loader = document.getElementById('loader') as HTMLButtonElement;
  if (startButton) {
    // eslint-disable-next-line no-console
    console.log('changing button state', startButton, innerText);
    if (innerText && startButton.childNodes && startButton.childNodes.length) {
      if (startButton.childNodes.length > 1) {
        startButton.childNodes[1].nodeValue = innerText;
      } else startButton.innerText = innerText;
    }
    startButton.disabled = disableButton;
  }
  if (loader) loader.style.display = 'none';
};

const hideSearchOrDesignHelpButton = () => {
  // eslint-disable-next-line no-console
  console.log('hiding search button');
  const { pageName } = isSearchOrDesignPage();
  const buttonName = pageName === 'Search' ? 'liveChatButton' : 'onlineBtn';
  const startButton = document.getElementById(buttonName) as HTMLButtonElement;
  if (startButton) {
    startButton.style.display = 'none';
    startButton.disabled = true;
  }
};

async function isBannerPage() {
  try {
    if (Object.keys(bannerCache.bannerPageURls).length === 0 || !bannerCache || !bannerCache.bannerPageURls) {
      try {
        const response = await fetch('https://caretech-ux-mods-prod.s3.amazonaws.com/bannerPages.json');
        const data = await response.json();
        bannerCache = data;
      } catch (error) {
        console.error(error);
        bannerCache = { bannerPageURls: {} };
      }
    }

    console.info('Banner Cache', bannerCache);
    const currentURL = window.location.href;
    let matchedStyle = null;
    let allowed = false;

    if (bannerCache && bannerCache.bannerPageURls && Object.keys(bannerCache.bannerPageURls).length) {
      const allUrlsArray = Object.keys(bannerCache.bannerPageURls);
      allUrlsArray.forEach((url) => {
        const endPath = currentURL.split('/').pop();
        console.info('End path', endPath);
        if (endPath && endPath.includes(url)) {
          matchedStyle = bannerCache.bannerPageURls[url];
          allowed = true;
        }
      });

      return { allowed, matchedStyle };
    }

    return false;
  } catch (error) {
    console.error('Error checking chat allowance:', error);
    return false;
  }
}

const updatePPAGInlineButton = (buttonText: string, disabled: boolean, matchedStyle?: string) => {
  console.info('###UPDATE PPAGE', buttonText);

  const chatbuttons = document.querySelectorAll('#start-chat-button');

  chatbuttons.forEach((button) => {
    (button as HTMLAnchorElement)?.removeAttribute('href');
    if (!disabled) {
      button.removeAttribute('disabled');
      (button as HTMLButtonElement).onclick = () => {
        window.embedded_svc.onHelpButtonClick();
      };
    } else {
      button.setAttribute('disabled', 'true');
      (button as HTMLAnchorElement).onclick = () => {
        console.info('PPAG  button disabled');
      };
    }

    (button as HTMLAnchorElement).innerHTML = ` <img
    src="${
      disabled
        ? 'https://cms.cloudinary.vpsvc.com/image/upload/fl_sanitize,q_auto/help_center/chat-icon-disabled.svg'
        : matchedStyle === 'white'
        ? 'https://cms.cloudinary.vpsvc.com/image/upload/fl_sanitize,q_auto/help_center/chat-icon-black.svg'
        : 'https://cms.cloudinary.vpsvc.com/image/upload/fl_sanitize,q_auto/help_center/chat-icon-white.svg'
    }"
    alt="image"
    class="swan-icon swan-icon-mask swan-icon-size-standard swan-icon-skin-standard swan-icon-type-image caHelpIconBg"
    id="caButtonIcon"
  />${buttonText}`;

    if (matchedStyle === 'black' && !disabled) {
      (button as HTMLAnchorElement).style.backgroundColor = '#000000';
      (button as HTMLAnchorElement).style.borderColor = '#000000';
      (button as HTMLAnchorElement).style.color = '#ffffff';
    }
    if (matchedStyle === 'white' && !disabled) {
      (button as HTMLAnchorElement).style.backgroundColor = '#ffffff';
      (button as HTMLAnchorElement).style.borderColor = '#ffffff';
      (button as HTMLAnchorElement).style.color = '#000000';
    }
    if (disabled) {
      (button as HTMLAnchorElement).style.backgroundColor = '#dfdfdf';
      (button as HTMLAnchorElement).style.borderColor = '#dfdfdf';
      (button as HTMLAnchorElement).style.color = '#9e9e9e';
    }
  });
};

export {
  isSearchOrDesignPage,
  hideSearchOrDesignHelpButton,
  updateStudioButton,
  isStudioButtonEnabled,
  isBannerPage,
  updatePPAGInlineButton,
  updateButtonState,
};
export default updateButtonState;
